import JobCardView from "./JobCardView";

export default JobCardView;